import axios from 'axios';

const api = axios.create({
  baseURL: process.env.VUE_APP_API,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});
const apiMain = axios.create({
  baseURL: process.env.VUE_APP_APIMAIN,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

const vendor = axios.create({
  baseURL: process.env.VUE_APP_VENDOR,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

const servicePayment = axios.create({
  baseURL: process.env.VUE_APP_PAYMENT,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

function vendorParams (id) {
  return new Promise((resolve, reject) => {
    vendor.get(`/vendors/${id}`).then(({ data }) => {
      resolve(data);
    }).catch((err) => {
      reject(err);
    });
  });
}

export {
  vendorParams,
  api,
  servicePayment,
  apiMain
};
